'use client';

import {type FC} from 'react';
import clsx from 'clsx';

interface Props {
	videoId: string;
	title: string;
}

export const VideoPlayer: FC<Props> = ({videoId, title}: Props) => {
	const videoParams = `autoplay=0&loop=0&autopause=0&title=0&byline=0&portrait=0&controls=1&muted=0&background=0`;

	return (
		<div className={clsx('pt-[56.25%]', 'relative', 'w-full', 'h-full')}>
			<iframe
				name="vimeo-player"
				title={title ?? 'vimeo-player'}
				src={`https://player.vimeo.com/video/${videoId}?${videoParams}`}
				allow="fullscreen;"
				className={clsx(
					'absolute',
					'top-0',
					'left-0',
					'w-full',
					'h-full',
				)}
			></iframe>
		</div>
	);
};
